export const program = (state) => state.program || {}

export const isLoading = (state) => state.isLoading || false
